var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeshorts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "35px",
    height: "39px",
    viewBox: "0 0 35 39",
    enableBackground: "new 0 0 35 39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 35,
    height: 39,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAnCAMAAACylgF9AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAnFBMVEUAAAD/AAD7AAD6AAD/ AAD8AAD+AAD9AAD9AAD/AAD+AAD9AAD9AAD9AAD7AAD9AAD8AAD+AAD8AAD9AAD9AAD/AAD+AAD8 AAD7AAD/AAD7AAD/AAD8AAD/AAD+AAD6AAD9AAD9GRn++fn+nZ3+29v9XV3+2tr9TEz+nJz++Pj+ fn7+6en9bW39jIz9CAj9urr9Kir9PDz9fX3///8kEXkeAAAAIHRSTlMAIEAwEGC/n/5/r3Dv34/e oM5Qz+6Ovq+AIUGAvl+ucAiMZVgAAAABYktHRDM31XxeAAAAB3RJTUUH5gURDywRdFHh1AAAASFJ REFUOMudlNtWwjAQRdOkwaA0oRoVFSVERRHFy/9/nCwamplmhgfOW7N253oSIU5XJVV9nNCjsNNZ xRNyT+xkxlyW89DLXFBEPZ4EIEOk003AsmwhWW6QZhpKGYTgQihGNYFUC5AJjYCaKyZKcLn3KYOY y5zqqj9dQsRrUHE+js+ZsmjzgIkvr4coeA8NYGJcvaWPaxhohJgY31NCByA9YOL6o6NuqECJ2Xym 5iXYZ4uYr+3hn1tY9sz3zPcPGBHq7W7fXFyvfllv3Hclbf62EEFxHtIZJkKYl0ix1MfsDQaBFuO8 AewDvIH0BPdFOrWVsG9BWNUvBpevvHu2eFkWw6koUah2qBspKCmfC5lxD5hyphusPfbE6bk3zipx mv4BEKVXtWJQmgsAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDUtMTdUMTI6NDQ6MTcrMDM6MDA5 wAfFAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTA1LTE3VDEyOjQ0OjE3KzAzOjAwSJ2/eQAAAABJ RU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeshorts);
export default __webpack_public_path__ + "static/media/youtubeshorts.a9acb8e7.svg";
export { ForwardRef as ReactComponent };